import { equals } from 'ol/coordinate'
import { fromLonLat } from 'ol/proj'
import { ADDRESS_ZOOM, locateAddress } from '@/services/addressSearch/addressSearchService'

/**
 * Moves a map view to an address once it has been located. Looking it up takes a moment, so the view
 * is left alone when it moved in the meantime (the user panned, or the map zoomed to something else)
 * or when `isStillWanted` says the address no longer matters.
 * @param {import('ol/View').default} view
 * @param {string} query address as search text, see getProjectAddressQuery
 * @param {() => boolean} isStillWanted
 * @returns {Promise<boolean>} whether the address was found, also when the view was then left alone;
 * false is the caller's cue to fall back to its own way of focusing the map
 */
export async function zoomToAddress (view, query, isStillWanted = () => true) {
  const startCenter = view.getCenter()
  const startZoom = view.getZoom()
  const location = await locateAddress(query)
  if (!location) {
    return false
  }
  if (isStillWanted() && view.getZoom() === startZoom && equals(view.getCenter(), startCenter)) {
    view.animate({ center: fromLonLat(location.lonLat, view.getProjection()), zoom: ADDRESS_ZOOM[location.precision], duration: 600 })
  }
  return true
}
